(function pageTransitionController(root) {
  'use strict';

  var transitionClass = 'is-page-transitioning';
  var barClass = 'site-page-transition';
  var safetyTimer = null;

  function prefersReducedMotion() {
    return Boolean(root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function ensureBar() {
    var documentReference = root.document;
    var bar = documentReference.querySelector('.' + barClass);

    if (bar) {
      return bar;
    }

    bar = documentReference.createElement('span');
    bar.className = barClass;
    bar.setAttribute('aria-hidden', 'true');
    documentReference.body.appendChild(bar);

    return bar;
  }

  function showTransition() {
    if (!root.document || !root.document.documentElement || !root.document.body) {
      return;
    }

    ensureBar();
    root.document.documentElement.classList.add(transitionClass);

    if (safetyTimer) {
      root.clearTimeout(safetyTimer);
    }

    safetyTimer = root.setTimeout(function clearStuckTransition() {
      root.document.documentElement.classList.remove(transitionClass);
      safetyTimer = null;
    }, prefersReducedMotion() ? 600 : 5000);
  }

  function hideTransition() {
    if (!root.document || !root.document.documentElement) {
      return;
    }

    root.document.documentElement.classList.remove(transitionClass);

    if (safetyTimer) {
      root.clearTimeout(safetyTimer);
      safetyTimer = null;
    }
  }

  function isNavigationClick(event) {
    if (!event || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return false;
    }

    var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;

    if (!link || link.target || link.hasAttribute('download')) {
      return false;
    }

    try {
      var url = new URL(link.href, root.location.href);

      if (url.origin !== root.location.origin) {
        return false;
      }

      if (url.pathname === root.location.pathname && url.search === root.location.search && url.hash) {
        return false;
      }

      return true;
    } catch (error) {
      return false;
    }
  }

  if (root.document) {
    root.document.addEventListener('click', function handleDocumentClick(event) {
      if (isNavigationClick(event)) {
        showTransition();
      }
    }, true);

    root.addEventListener('beforeunload', showTransition);
    root.addEventListener('pageshow', hideTransition);

    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', ensureBar, { once: true });
    } else {
      ensureBar();
    }
  }
})(typeof window !== 'undefined' ? window : globalThis);
